import styled from 'styled-components';

const Space = styled.span`
  padding-right: 5px;
`;

export default Space;
